export default __webpack_public_path__ + "static/media/Carlos G.c57adfc6.png";